<template lang="html">
  <div class="compare-pwds">
    <div class="field">
      <label for="password1" class="label">Senha <span v-if="required" class="required">*</span></label>
      <div class="control">
        <input type="password"
          class="input"
          :class="{ 'is-danger': showMinHelpMsg, 'is-success': isEqual }"
          id="password1"
          @change="compareValues"
          v-model="password1"
          placeholder="Digite uma senha"
          :required="required"
          :disabled="disabled"
        >
        <span class="help" v-if="showMinHelpMsg">A senha precisa ter pelo menos 6 caracteres</span>
      </div>
    </div>
    <div class="field">
      <label for="password2" class="label">Confirme sua senha <span v-if="required" class="required">*</span></label>
      <div class="control">
        <input type="password"
          ref="input"
          class="input"
          :class="{ 'is-danger': showMinHelpMsg, 'is-success': isEqual }"
          id="password2"
          @change="compareValues"
          v-model="password2"
          placeholder="Confirme sua senha"
          :required="required"
          :disabled="disabled"
        >
        <span class="help" v-if="showHelpMessage">As senhas informadas não coincidem</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComparePasswords',
  props: {
    value: {
      default: ''
    },
    required: {
      default: false
    },
    min: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEqual: '',
      password1: '',
      password2: '',
      showMinHelpMsg: false
    }
  },
  computed: {
    showHelpMessage: function () {
      if (this.isEqual === '') {
        return false
      } else {
        return !this.isEqual
      }
    }
  },
  methods: {
    compareValues: function (event) {
      if (this.password1.length < 6) {
        this.showMinHelpMsg = true
      } else {
        this.showMinHelpMsg = false
      }
      if (this.password1 === this.password2) {
        this.isEqual = true
        this.$emit('input', this.password1)
      } else {
        this.isEqual = false
        this.$emit('input', '')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ComparePwds.vue